<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :actions="grid.actions"
          :exportFileName="title"
          @on-row-action-click="gridRowClick"
          @on-add-click="add"
        />
      </v-card-text>
    </v-card>
    <role-modal :ref="modalKey" @on-item-saved="onItemSaved" />
  </div>
</template>

<script>
import RoleService from "@/services/RoleService";
import RoleModal from "@/components/administration/role/RoleModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    RoleModal,
  },

  data() {
    return {
      title: this.$t("Roles"),
      grid: {
        key: "roleGrid",
        dataSource: RoleService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
          {
            field: "Description",
            caption: this.$t("Description"),
            type: "string",
          },
        ],
        actions: [
          {
            name: "edit",
            icon: "mdi-pencil",
            tooltip: this.$t("Edit"),
            color: "primary",
          },
          {
            name: "delete",
            icon: "mdi-delete",
            tooltip: this.$t("Delete"),
            color: "red",
          },
        ],
      },
      modalKey: "modalRole",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    gridRowClick(action) {
      if (action.name === "edit") {
        this.edit(action.data);
      }
      if (action.name === "delete") {
        this.delete(action.data);
      }
    },
    edit(dto) {
      this.modalInstance.edit(dto);
    },
    delete(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          RoleService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(this.$t("Role") +" "+ this.$t("DeletedSuccessfully"));
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>